import { createVar } from '@vanilla-extract/css';
import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { globalStyle, style } from '../layer.css';

export const emptyStateContainer = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: '100%',
  containerType: 'inline-size',
  color: themeVars.container.foreground.primary,
  borderRadius: borderRadius.r12,

  padding: space.s24,

  '@container': {
    ['(min-width: 960px)']: {
      padding: space.s32,
    },
  },
});

const emptyStateIconSizeVar = createVar();

export const emptyStateContent = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: space.s16,
  maxWidth: '370px',

  vars: {
    [emptyStateIconSizeVar]: '32px',
  },

  '@container': {
    ['(min-width: 960px)']: {
      vars: {
        [emptyStateIconSizeVar]: '40px',
      },
    },
  },
});

globalStyle(`.${emptyStateContent} :where(svg)`, {
  width: emptyStateIconSizeVar,
  height: emptyStateIconSizeVar,
});

export const emptyStateContentText = style({
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,

  '@container': {
    ['(min-width: 960px)']: {
      gap: space.s16,
    },
  },
});

export const emptyStateHeading = style({
  ...typography['titleSm'],

  '@container': {
    ['(min-width: 960px)']: {
      ...typography['titleLg'],
    },
  },
});

export const emptyStateDescription = style({
  ...typography['labelSm'],
  color: themeVars.container.foreground.secondary,

  '@container': {
    ['(min-width: 960px)']: {
      ...typography['labelLg'],
    },
  },
});

export const emptyStateActions = style({
  marginTop: space.s16,
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,

  '@container': {
    ['(min-width: 960px)']: {
      gap: space.s16,

      marginTop: space.s24,
    },
  },
});
